<template>
  <div class="survey-form">
    <div class="top" ref="top"></div>
    <div class="title">
      <div class="back" @click="backQuestion"></div>
      问卷调查
    </div>
    <p class="text text-padding">
      蜗爷您好~辛苦您填一下我们的好评问卷，小橘可以知道蜗爷们的喜好为大家带来更多福利，我悄悄塞了一颗
      <span class="importantColor">龙珠</span>，填完即可领取~
    </p>
    <div class="line"></div>
    <form @submit.prevent="handleSubmit">
      <div v-for="(question, index) in questions" :key="index" class="question options-padding"
        :ref="'question' + index" :id="'question' + index">
        <p class="choose_text"> <span v-if="question.error" class="error">*</span>{{ question.text }}<span
            :class="question.error ? 'error' : ''" v-if="question.type === 'checkbox'">(多选)</span></p>
        <div>
          <div class="choose_item" v-for="(option, key) in question.options" :key="key">
            <label class="choose_text_item">
              <input class="choose_input" :type="question.type" :name="'question' + index" :value="key"
                v-model="responses[index].selected" @change="handleOptionChange(index, key)" />
              <!-- {{ option.text }} -->
              <span class="choose_input_text" v-html="option.text"></span>
            </label>

            <div v-if="option.other && responses[index].selected.includes(key)">
              <textarea :id="'otherInput' + index" v-model="responses[index].other" :maxlength="option.maxlength"
                rows="5" placeholder="请输入其他选项" @input="handleOtherChange(index, key)"
                :class="responses[index].other_error ? 'textareaInput textareaInput_error' : 'textareaInput'"></textarea>
              <div :class="responses[index].other_error ? 'char-counter textareaInput_error' : 'char-counter'">
                剩余字符: {{ remainingChars(index, option.maxlength) }}
              </div>
            </div>

          </div>
        </div>
      </div>
      <button :class="submitState ? 'submit_state sure' : 'sure'" type="submit"></button>
    </form>
  </div>
</template>


<script>
import { Toast, Indicator, Field } from 'mint-ui';
export default {
  mounted() {
    this.$refs.top.scrollIntoView({ behavior: 'auto' });
  },
  data() {
    return {
      questions: [
        {
          text: "1、蜗蜗您有另一半了吗，结婚了没有呀（您看我还有机会吗）",
          type: "radio",
          error: false,
          options: {
            A: { text: "结婚了，鹂没机会了" },
            B: { text: "还没，蜗一直在等鹂" }
          }
        },
        {
          text: "2、师傅您是做什么工作的",
          type: "radio",
          error: false,
          options: {
            A: { text: "学生" },
            B: { text: "打工人" },
            C: { text: "逆袭成功的老板" },
            D: { text: "无业游民" },
            E: { text: "铁饭碗" }
          }
        },
        {
          text: "3、除了手机您还喜欢什么设备玩游戏呢？",
          type: "checkbox",
          error: false,
          options: {
            A: { text: "PC" },
            B: { text: "switch" },
            C: { text: "PS" },
            D: { text: "XBOX" },
            E: { text: "平板" },
            F: { text: "无" },
          }
        },
        {
          text: "4、最近一个月，蜗蜗有在玩其他一些游戏吗，可以告诉一下不咯",
          type: "checkbox",
          error: false,
          options: {
            A: { text: "MOBA（王者荣耀、英雄联盟手游等）" },
            B: { text: "放置RPG<b style='color:red'>（最强蜗牛）</b>" },
            C: { text: "开放世界(原神、鸣潮、幻塔、绝区零等)" },
            D: { text: "MMORPG(逆水寒、一梦江湖、剑网三无界等)" },
            E: { text: "休闲益智(开心消消乐、保卫萝卜等)" },
            F: { text: "音舞（喵斯快跑、劲舞团、QQ炫舞手游等）" },
            G: { text: "竞速(巅峰极速、极品飞车、QQ飞车手游等)" },
            H: { text: "动作(崩坏3、晶核、战双帕弥什、火影忍者等)" },
            I: { text: "吃鸡(和平精英、荒野行动等)" },
            J: { text: "派对游戏(蛋仔派对、香肠派对、元梦之星等)" },
            K: { text: "经营养成(江南百景图、梦幻家园等)" },
            L: { text: "社交桌游(狼人杀、我是迷等)" },
            M: { text: "卡牌PRG(阴阳师、明日方舟、FGO等)" },
            N: { text: "情感/换装(光与夜之恋、代号鸢、闪耀暖暖等)" },
            O: { text: "其他", other: true, maxlength: 500, other_error: false }
          }
        },
        {
          text: "5、选择玩什么游戏的时候，蜗蜗比较在意的是哪些方面的内容呢",
          type: "checkbox",
          error: false,
          options: {
            A: { text: "剧情让我无法自拔" },
            B: { text: "画风长在审美上" },
            C: { text: "配乐怪好听的" },
            D: { text: "特瑟内容" },
            E: { text: "游戏里的人说话好听，我就超爱" },
            F: { text: "硬核，享受硬抠数值干掉怪物的爽感" },
            G: { text: "有繁多且有意思的游戏道具和成就让我收集" },
            H: { text: "其他", other: true, maxlength: 500, other_error: false }
          }
        },
        {
          text: "6、这个问卷会给猴子看的，所以您最希望接下来更新哪个方向的内容呀",
          type: "radio",
          error: false,
          options: {
            A: { text: "内容太多蜗还没体验完" },
            B: { text: "新系统新玩法" },
            C: { text: "剧情" },
            D: { text: "其他", other: true, maxlength: 144, other_error: false }
          }
        },
        {
          text: "7、然后还有，您觉得目前最有希望得到优化的玩法是哪些哇",
          type: "checkbox",
          error: false,
          options: {
            A: { text: "源兽批量升星" },
            B: { text: "重建神域的信徒研究和贵重摆放" },
            C: { text: "其他", other: true, maxlength: 144, other_error: false }
          }
        },
        {
          text: "8、最后，球球各位蜗爷！给小橘的第一次活动打个好评分吧~以后给大家疯狂薅福利！",
          type: "radio",
          error: false,
          options: {
            A: { text: "1（最低分）" },
            B: { text: "2" },
            C: { text: "3" },
            D: { text: "4" },
            E: { text: "5（最高分）" },
          }
        }
      ],
      responses: Array(8).fill(null).map(() => ({ selected: [], other: '' })),
      customResponses: Array(8).fill(null).map(() => ({})), // 初始化自定义响应数组
      submitState: false,
    };
  },
  methods: {
    handleOtherChange(questionIndex, optionKey) {
      const question = this.questions[questionIndex];
      const option = question.options[optionKey];
      if (question.type === "radio") {
        const keys = Object.keys(question.options);
        if (option.other && optionKey === keys[keys.length - 1]) {
          option.other_error = false;
          const inputElement = document.getElementById(`otherInput${questionIndex}`);
          if (inputElement) {
            inputElement.classList.remove('textareaInput_error');
          }
        }
      }
      const isChecked = this.responses[questionIndex].selected.includes(optionKey)
      if (option.other && isChecked) {
        option.other_error = false;
        const inputElement = document.getElementById(`otherInput${questionIndex}`);
        if (inputElement) {
          inputElement.classList.remove('textareaInput_error');
        }
      }
    },
    handleOptionChange(questionIndex, optionKey) {
      const question = this.questions[questionIndex];
      const option = question.options[optionKey];
      console.log(option);
      if (questionIndex === 7) {
        return this.onToast('感谢蜗爷的好评~')
      }
      if (question.type === "radio") {
        const keys = Object.keys(question.options);
        if (optionKey !== keys[keys.length - 1]) {
          option.other_error = false;
          this.responses[questionIndex].other = '';
          const inputElement = document.getElementById(`otherInput${questionIndex}`);
          if (inputElement) {
            inputElement.classList.remove('textareaInput_error');
          }
          return
        }
      }
      const isChecked = this.responses[questionIndex].selected.includes(optionKey)
      if (option.other && !isChecked) {
        option.other_error = false;
        this.responses[questionIndex].other = '';
        const inputElement = document.getElementById(`otherInput${questionIndex}`);
        if (inputElement) {
          inputElement.classList.remove('textareaInput_error');
        }
        this.$forceUpdate()
      }

    },
    remainingChars(index, maxlength) {
      const currentLength = this.responses[index].other.length;
      return maxlength - currentLength;
    },
    calculateWidth(input) {
      return Math.max(input.length, 10); // 最小宽度为 10 个字符
    },
    backQuestion() {
      let stop = false;
      const that = this;
      const result = this.responses.map((response, index) => {
        const selectedKeys = Array.isArray(response.selected) ? response.selected : [response.selected];
        if (selectedKeys.length === 0) {
          stop = true;
          return null;
        }
      })
      this.$emit('backQuestion', stop);
      console.log('返回上一题');
    },
    handleSubmit() {
      let stop = false;
      const that = this;
      const answers = []
      const result = this.responses.map((response, index) => {
        const selectedKeys = Array.isArray(response.selected) ? response.selected : [response.selected];
        // if (this.questions[index].type === "checkbox" && selectedKeys.length < 2) {
        //   stop = true;
        //   answers.push(index);
        //   this.questions[index].error = true;
        //   return null;
        // } else {
        //   this.questions[index].error = false;
        // }
        if (selectedKeys.length === 0) {
          stop = true;
          answers.push(index)
          that.questions[index].error = true;
          return null;
        } else {
          this.questions[index].error = false;
        }
        const selectedValues = selectedKeys.map(key => {
          let val = key + '.' + this.questions[index].options[key].text || '';
          if (this.questions[index].options[key].hasOwnProperty('other') && this.questions[index].options[key].other) {
            val = val + response.other || '';
            if (!response.other && response.other.length < 2) {
              stop = true;
              // response.other_error = true;

              const inputElement = document.getElementById(`otherInput${index}`);
              if (inputElement) {
                inputElement.classList.add('textareaInput_error');
              }
              const keys = Object.keys(that.questions[index].options);
              that.questions[index].options[keys[keys.length - 1]].other_error = true
              that.questions[index].error = true;
              answers.push(index)
              return null;
            } else {
              response.other_error = false;
              that.questions[index].error = false;
            }
          }
          if (index === 7) {
            val = this.questions[index].options[key].text.split("（")[0]
          }
          return val;
        });
        return {
          question: this.questions[index].text,
          selectedKeys,
          selectedValues
        };
      });
      console.log("Form submitted with responses:", result);
      if (stop) {
        this.$set(this.questions, this.questions);
        this.onToast('当前题目未作答，请作答跳转下一题~')
        if (answers[0] === 3) {
          let question = `question` + (answers[0] - 1);
          this.$refs[question][0].scrollIntoView({ behavior: 'smooth' });
          return
        }
        let question = `question` + (answers[0]);
        this.$refs[question][0].scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      this.submitState = true
      this.onToast('亲爱滴蜗爷~龙珠已送达至您的邮箱~')
      this.$emit('submit', result);
    },
    onToast(config) {
      const curConfig = {
        duration: 2000,
        className: 'toasts'
      };
      if (!config) {
        console.error('缺少config参数');
        return false;
      }
      if (typeof config === 'string') {
        curConfig.message = config;
      }
      Toast(curConfig);
    },
  }
};
</script>


<style lang="less" scoped>
@import url("~@/assets/css/active.less");
@import url("~@/assets/css/consts.less");
@import url("~@/assets/css/common.less");
@import url("~@/assets/css/animation.less");

@mainImageUrl: '@{imageUrl}active/snail/doubleDan/';

.survey-form {
  max-width: 95%;
  margin: auto;
  margin-bottom: 5%;
  font-family: 'Noto Sans SC', sans-serif;
  font-weight: 400;
  font-style: normal;

  .top {
    position: absolute;
    top: 0px;
  }
}

.submit_state {
  filter: brightness(70%);
}

.char-counter {
  font-size: 18px;
  color: #666;
  text-align: right;
  margin-top: 4px;
}

.title {
  width: 100%;
  text-align: center;
  font-size: 36px;
  font-family: 'Noto Sans SC', sans-serif;
  font-weight: 700;
  line-height: 88px;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;

  .back {
    width: 17px;
    height: 32px;
    position: absolute;
    background: url('@{mainImageUrl}back.png') no-repeat center center;
    background-size: contain;
    left: 12px;
    cursor: pointer;
  }
}

.text {
  font-weight: 500;
  font-size: 30px;
  color: #2E2E2E;
  line-height: 38px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}

.text-padding {
  padding: 0px 15px;
}

.options-padding {
  padding: 0px 11px;
}

.line {
  width: 670px;
  height: 6px;
  background-image: radial-gradient(circle, black 10%, transparent 40%);
  background-size: 6px 6px;
  margin-top: 36px;
  margin-bottom: 31px;
}

.choose_item {
  margin-bottom: 51px;

  .inputRadio {
    border: none;
    border-bottom: 2px solid #000;
    outline: none;
    padding: 5px;
    transition: border-color 0.3s;
    width: auto;
    min-width: 10ch;
    /* 设置最小宽度 */
    max-width: 100%;

    /* 最大宽度为100% */
    &:focus {
      border-bottom-color: #007BFF;
    }

  }

  .textareaInput {
    margin-top: 10px;
    width: 100%;
    min-height: 50px;
    border: 2px solid #000;
    outline: none;
    padding: 5px;
    resize: vertical;
    /* 允许用户垂直调整大小 */
    transition: border-color 0.3s;

    &:focus {
      border-color: #007BFF;
    }
  }

  .textareaInput_error {
    border-color: red !important;
  }
}

.choose_text {
  font-family: 'Noto Sans SC', sans-serif;
  font-weight: bold;
  font-size: 30px;
  color: #2E2E2E;
  line-height: 36px;
  text-align: left;
  font-style: normal;
  text-transform: none;
  margin-bottom: 24px;

  .error {
    color: red;
    margin: 4px;

  }
}

.choose_item_flex {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.choose_item_flex_column {
  flex-direction: column;
}

.choose_block {
  display: block;
}

.choose_text_item {
  font-family: 'Noto Sans SC', sans-serif;
  font-weight: 500;
  font-size: 26px;
  color: #2E2E2E;
  line-height: 40px;
  text-align: left;
  font-style: normal;
  text-transform: none;
  margin-right: 10px;
  margin-bottom: 10px;

  input[type="radio"],
  input[type="checkbox"] {
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    position: relative;
    display: inline-block;
    width: 27px;
    height: 27px;
    margin: 0;
    padding: 0;
    top: 4%;
    cursor: pointer;
  }

  input[type="radio"]::before,
  input[type="checkbox"]::before {
    content: "";
    position: absolute;
    display: inline-block;
    width: 100%;
    height: 100%;
    background: url('@{mainImageUrl}dot.png') no-repeat center center;
    background-size: contain;
    left: 0%;
  }

  input[type="radio"]:checked::after,
  input[type="checkbox"]:checked::after {
    content: "";
    position: absolute;
    display: inline-block;
    width: 100%;
    height: 100%;
    background: url('@{mainImageUrl}dot_active.png') no-repeat center center;
    background-size: contain;
    left: 0%;
  }
}

.question {
  margin-bottom: 20px;
}

.importantColor {
  color: rgba(237, 129, 41, 1) !important;
}

.sure {
  display: block;
  width: 314px;
  height: 88px;
  cursor: pointer;
  background: url('@{mainImageUrl}sure.png') no-repeat center center;
  background-size: contain;
  border: none;
  margin-left: calc(50% - 157px);
  margin-top: 65px;
  cursor: pointer;
}

.choose_input_text {
  position: relative;
  top: -4px;
}
</style>



// WEBPACK FOOTER //
// src/pages/snail/doubleDan/myform/index.vue